export const BodyViewsByPageTitle = (startDate, endDate, customDimensionFilter) => {
  const baseQuery = {
    dimensions: [{ name: "hostName" }],
    metrics: [{ name: "screenPageViews" }],
    dateRanges: [{ startDate, endDate }],
  };

  if (customDimensionFilter) {
    return {
      ...baseQuery,
      dimensionFilter: customDimensionFilter,
    };
  } else {
    return baseQuery;
  }
};

export const BodyViewsByPages = (startDate, endDate, customDimensionFilter) => {
  const baseQuery = {
    dimensions: [{ name: "unifiedPagePathScreen" }],
    metrics: [{ name: "screenPageViews" }],
    dateRanges: [{ startDate, endDate }],
  };

  if (customDimensionFilter) {
    return {
      ...baseQuery,
      dimensionFilter: customDimensionFilter,
    };
  } else {
    return baseQuery;
  }
};

export const BodyUsersByCity = (startDate, endDate, customDimensionFilter) => {
  const baseQuery = {
    dimensions: [{ name: "city" }],
    metrics: [{ name: "activeUsers" }],
    dateRanges: [{ startDate, endDate }],
  };

  if (customDimensionFilter) {
    return {
      ...baseQuery,
      dimensionFilter: customDimensionFilter,
    };
  } else {
    return baseQuery;
  }
};

export const BodySessionByChannel = (startDate, endDate, customDimensionFilter) => {
  const baseQuery = {
    dimensions: [{ name: "sessionDefaultChannelGroup" }],
    metrics: [{ name: "activeUsers" }, { name: "newUsers" }],
    dateRanges: [{ startDate, endDate }],
  };

  if (customDimensionFilter) {
    return {
      ...baseQuery,
      dimensionFilter: customDimensionFilter,
    };
  } else {
    return baseQuery;
  }
};

export const BodyViewsByUserSource = (startDate, endDate, customDimensionFilter) => {
  const baseQuery = {
    dimensions: [{ name: "firstUserSource" }],
    metrics: [{ name: "activeUsers" }],
    dateRanges: [{ startDate, endDate }],
  };

  if (customDimensionFilter) {
    return {
      ...baseQuery,
      dimensionFilter: customDimensionFilter,
    };
  } else {
    return baseQuery;
  }
};

  export const BodyUsers30MinAgo = (startDate, endDate) => ({
    dimensions: [{ name: "unifiedScreenName" }],
    metrics: [{ name: "activeUsers" }],
    minuteRanges: [{ startMinutesAgo:29, endMinutesAgo:0 }],
  });